import { call, put, select, takeLatest } from 'redux-saga/effects'
import { getServiceIdSelector } from '../../user/selectors'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { VitalsService } from '../../vitals/services/vitals.service'
import { setApgarActivityOptions } from '../store/options.actions'
import { IOptionsResponse } from '../../../common/common.types'
import { ClientDataConstants } from '../../clientData/store/clientData.constants'

export function* getApgarActivityOptions() {
  const serviceId: string = yield select(getServiceIdSelector)
  const vitalsService = new VitalsService(serviceId)
  try {
    const apgarActivity: IOptionsResponse = yield call([vitalsService, vitalsService.getApgarActivity])
    const { entity } = apgarActivity
    yield put(setApgarActivityOptions(entity))
  } catch (e) {
    yield put(throwPcrException(`getApgarActivityOptions() error: ${e}`))
  }
}

export function* getApgarActivityOptionsSaga() {
  yield takeLatest(ClientDataConstants.ON_CLIENT_DATA_IMPORT_SUCCESS, getApgarActivityOptions)
}
